import { createTheme } from "@mui/material";

export function darkTheme() {
  return createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#3B82F6",
        light: "#60A5FA",
        dark: "#1D4ED8",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#22C55E",
        light: "#86EFAC",
        dark: "#15803D",
        contrastText: "#ffffff",
      },
      background: {
        default: "#1E293B",
        paper: "#273549",
      },
      text: {
        primary: "#F1F5F9",
        secondary: "#CBD5E1",
      },
    },
    typography: {
      allVariants: {
        color: "#F1F5F9",
      },
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    components: {
      // Configuração do Modal
      MuiModal: {
        styleOverrides: {
          root: {
            backgroundColor: "rgba(0, 0, 0, 0.8)", // Backdrop mais escuro
          },
        },
      },
      // Configuração do Backdrop
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: "rgba(0, 0, 0, 0.8)", // Backdrop escuro
          },
        },
      },
      // Configuração do Paper (conteúdo do modal)
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "#273549", // Cor do tema
            color: "#F1F5F9",
          },
        },
      },
      // Configuração dos Inputs
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: "#334155",
            borderRadius: "6px",
            boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#475569",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#3B82F6",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#3B82F6",
              boxShadow: "0 0 0 1px #3B82F633",
            },
          },
          input: {
            color: "#F1F5F9",
          },
        },
      },
      // Configuração dos Botões
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none", // Remove o uppercase
          },
          outlined: {
            borderColor: "#475569",
            color: "#F1F5F9",
            "&:hover": {
              borderColor: "#3B82F6",
              backgroundColor: "rgba(59, 130, 246, 0.1)",
            },
          },
        },
      },
      // Configuração das Lists
      MuiList: {
        styleOverrides: {
          root: {
            backgroundColor: "#273549",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            color: "#F1F5F9",
          },
        },
      },
      MuiInputBase: {
        defaultProps: {
          size: "medium",
        },
      },
    },
  });
}